import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MODAL_DATA } from '../tokens/modal-data.token';
import { NotificationDto } from '../types/notification-dto';
import { NotificationEventType } from '../types/notification-event-type';
import { FeedbackRequestType } from '../types/feedback-request-type';
import { formatTeacherResponseText } from '../utils/text-utils';

@Component({
  selector: 'lp2-generic-notification',
  templateUrl: './generic-notification.component.html',
  styleUrls: ['./generic-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericNotificationComponent {
  get notification(): NotificationDto {
    if (this.data.title === FeedbackRequestType.ASK_A_TEACHER) {
      this.data.notification = formatTeacherResponseText(this.data.notification);
    }
    return this.data;
  }

  get isLevelTestNotification(): boolean {
    return this.notification.type === NotificationEventType.MID_LEVEL_TEST;
  }

  constructor(@Inject(MODAL_DATA) private data: NotificationDto) {}
}



// WEBPACK FOOTER //
// ./ts/app/shared/generic-notification/generic-notification.component.ts